import styled from "styled-components"

const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;

    width: 100%;
    height: 52px;
    margin-right: 16px;
`

export default InputWrapper